import React from "react";
import "./index.css";

const Mission = () => {
  return (
    <div className="SubPiller">
      <h1 className="mission-heading">Our Mission</h1>
      <p className="mission-detials">
        "Ko'olauloa Foundation focuses on Hawaiian Farming,
        <br /> Eduction, Health, Culture, and Community Programs"
      </p>
    </div>
  );
};

export default Mission;
